<script>
  export let workoutPlan
  export let workout

  import carouselable from '../components/carouselable.js'
  import { createEventDispatcher, tick } from 'svelte'

  const dispatch = createEventDispatcher()

  const slideMapSet = {}
  const slideMapExercise = {}
  let currentSet
  let currentPlanSet
  let currentExercise
  let currentPlanExercise
  let currentExerciseAmount

  // Add a numbered index field to each item denoting which slide number it is
  let i = 0
  workoutPlan.sets.forEach((planSet) => {
    planSet.index = i++
    slideMapSet[planSet.index] = planSet
    planSet.exercises.forEach((planExercise) => {
      planExercise.index = i++
      slideMapExercise[planExercise.index] = planExercise
    })
  })

  // Remember the index of the last slide
  const doneSlideIndex = i++

  function startExercise(planExercise) {
    currentPlanExercise = planExercise
    currentExercise = currentSet.exercises.find(
      (e) => e.plan_exercise == planExercise.url
    )

    console.log('startExercise', currentExercise)
    dispatch('startExercise', {
      exercise: currentExercise,
      planExercise: currentPlanExercise,
    })
  }

  function finishExercise() {
    console.log('finishExercise', currentExercise)
    dispatch('finishExercise', {
      exercise: currentExercise,
      planExercise: currentPlanExercise,
    })
    currentExercise = undefined
    currentPlanExercise = undefined
  }

  function startSet(planSet) {
    currentPlanSet = planSet
    currentSet = workout.sets.find((s) => s.plan_set == planSet.url)
    console.log('startSet', currentSet)
    dispatch('startSet', { set: currentSet, planSet: currentPlanSet })
  }

  function finishSet() {
    console.log('finishSet', currentSet)
    dispatch('finishSet', { set: currentSet, planSet: currentPlanSet })
    currentSet = undefined
    currentPlanSet = undefined
  }

  function carouselSlide(e) {
    console.log('Carousel', e)
    console.log('currentSet', currentSet)
    console.log('currentExercise', currentExercise, currentExerciseAmount)

    if (currentExercise) {
      // Finish the last exercise if there was one
      finishExercise()
    }

    if (slideMapSet[e.to]) {
      // New Set Slide
      // Last Exercise was already finished above
      if (currentSet) {
        // If there was a previous set, finish it
        finishSet()
      }

      // Start a new Set
      startSet(slideMapSet[e.to])
    } else if (slideMapExercise[e.to]) {
      // New Exercise Slide, start exercise
      // Last Exercise was already finished above
      startExercise(slideMapExercise[e.to])
    } else if (e.to == doneSlideIndex) {
      // Last Slide, finish set and workout if started
      // Exercise was already finished above

      if (currentSet) {
        finishSet()
      }
      dispatch('finishWorkout')
    }
  }

  // Calculate where to start
  let startSlide
  if (workout.sets.length == 0 || !workout.sets[0].start) {
    console.log('New Workout, starting from slide 0')
    startSlide = 0
  } else {
    workout.sets.forEach((set) => {
      const planSet = workoutPlan.sets.find((s) => s.url == set.plan_set)
      set.exercises.forEach((ex) => {
        const planEx = planSet.exercises.find(
          (pex) => pex.url == ex.plan_exercise
        )
        if (!ex.finish && !startSlide) {
          startSlide = planEx.index
          currentSet = set
          console.log(
            'Resuming Workout, starting at slide ' + startSlide + ' for',
            ex,
            planEx
          )
        }
      })
    })
  }

  tick().then(() => {
    carouselSlide({ to: startSlide })
  })
</script>

<div class="d-flex justify-content-center align-items-center">
  <div style="width: 100%; max-width: 720px;">
    <div
      id="wpc"
      class="carousel slide"
      use:carouselable={{ interval: false, wrap: false }}
      on:slid.bs.carousel={carouselSlide}
    >
      <div class="carousel-indicators">
        {#each workoutPlan.sets as set, seti (set.id)}
          <button
            type="button"
            data-bs-target="#wpc"
            data-bs-slide-to={set.index}
            class:active={set.index == startSlide}
            class="bg-warning"
          />
          {#each set.exercises as exercise, exi (exercise.id)}
            <button
              type="button"
              data-bs-target="#wpc"
              data-bs-slide-to={exercise.index}
              class:active={exercise.index == startSlide}
            />
          {/each}
        {/each}
        <button
          type="button"
          data-bs-target="#wpc"
          data-bs-slide-to={doneSlideIndex}
          class="bg-danger"
        />
      </div>

      <div class="carousel-inner">
        {#each workoutPlan.sets as set, seti (set.id)}
          <div class="carousel-item" class:active={set.index == startSlide}>
            <div
              class="d-flex justify-content-center align-items-center bg-info"
              style="height: 350px;"
            >
              <div>
                <h3>Set {seti + 1}</h3>
                <p>Work Hard!</p>
              </div>
            </div>
          </div>
          {#each set.exercises as exercise, exi (exercise.id)}
            <div
              class="carousel-item"
              class:active={exercise.index == startSlide}
            >
              <div
                class="d-flex justify-content-center align-items-center bg-secondary text-light"
                style="height: 350px;"
              >
                <div>
                  <i>{exercise.index}</i>
                  <h5>{exercise.exercise.name}</h5>
                  <p>
                    {#if exercise.execution_type == 'count_based'}
                      repeat {exercise.amount} times
                    {:else}
                      repeat for {exercise.amount} seconds
                    {/if}
                  </p>
                </div>
              </div>
            </div>
          {/each}
        {/each}
        <div class="carousel-item" class:active={doneSlideIndex == 0}>
          <div
            class="d-flex justify-content-center align-items-center bg-info"
            style="height: 350px;"
          >
            <div>
              <h1>Done</h1>
              <p>Great success!</p>
            </div>
          </div>
        </div>
      </div>
      <button
        class="carousel-control-prev"
        type="button"
        data-bs-target="#wpc"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" />
      </button>
      <button
        class="carousel-control-next"
        type="button"
        data-bs-target="#wpc"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" />
      </button>
    </div>
  </div>
</div>
